// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import axios from 'axios'
import vueSwiper from 'vue-awesome-swiper'
import 'swiper/swiper.less'
import Video from 'video.js'
import 'video.js/dist/video-js.css'
Vue.prototype.$http = axios
Vue.prototype.$video = Video
Vue.use(vueSwiper)
Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
}) 
